/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { AssetTransfer, AssetWithTransfer, Blank, Effect, Nullable, Pagination, Setter } from "../../utils/Interfaces";
import { getHandler, postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { AxiosResponse } from "axios";

export function createAssetTransfer(
    assetId: number,
    toUserId: number,
    notes: Nullable<string>,
    dispatch: Dispatch<AnyAction>,
    onAssetTransferCreated: Effect,
    setLoading: Setter<boolean>
): void {
    postHandler<Blank, Blank>(
        `/api/assets/transfers/create/${assetId}/${toUserId}`,
        { notes: notes },
        dispatch,
        () => onAssetTransferCreated(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function cancelAssetTransfer(
    assetTransferId: number,
    notes: string,
    dispatch: Dispatch<AnyAction>,
    onAssetTransferCancelled: Effect,
    setLoading: Setter<boolean>
): void {
    postHandler<Blank, Blank>(
        `/api/assets/transfers/cancel/${assetTransferId}`,
        { notes: notes },
        dispatch,
        () => onAssetTransferCancelled(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function acceptAssetTransfer(
    assetTransferId: number,
    dispatch: Dispatch<AnyAction>,
    onAssetTransferAccepted: Effect,
    setLoading: Setter<boolean>
): void {
    postHandler<Blank, Blank>(
        `/api/assets/transfers/accept/${assetTransferId}`,
        {},
        dispatch,
        () => onAssetTransferAccepted(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function updateMyAssets(
    dispatch: Dispatch<AnyAction>,
    setAssets: Setter<AssetWithTransfer[]>,
    setLoading: Setter<boolean>
): void {
    getHandler<Pagination<AssetWithTransfer>>(
        "/api/assets/list-my-assets",
        dispatch,
        (response: AxiosResponse<Pagination<AssetWithTransfer>, any>) => setAssets(response.data.results),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function updateOpenAssetTransfers(
    dispatch: Dispatch<AnyAction>,
    setAssetTransfers: Setter<AssetTransfer[]>,
    setLoading: Setter<boolean>
): void {
    getHandler<Pagination<AssetTransfer>>(
        "/api/assets/transfers/list-open",
        dispatch,
        (response: AxiosResponse<Pagination<AssetTransfer>, any>) => setAssetTransfers(response.data.results),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function updateMyAssetsToReceive(
    dispatch: Dispatch<AnyAction>,
    setAssetsToReceive: Setter<AssetTransfer[]>,
    setLoading: Setter<boolean>
): void {
    getHandler<Pagination<AssetTransfer>>(
        "/api/assets/transfers/my-assets-to-receive",
        dispatch,
        (response: AxiosResponse<Pagination<AssetTransfer>, any>) => setAssetsToReceive(response.data.results),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
